import {Injectable} from '@angular/core';
import {HttpService} from '../http-service.service';
import {ApiConst, KindOfRequest} from '../api-const';
import {AuthenticationService} from '../security/authentication.service';
import {StorageService} from '../../storage/storage.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Message, MessageService} from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ModService {
  isLogged: boolean;
  messageOfTheDay: any;

  constructor(private httpService: HttpService,
              private storageService: StorageService,
              private authService: AuthenticationService) {
    this.authService.isLogged.subscribe(logResult => {
      this.isLogged = logResult;
    });
    this.getPlatformMessages().subscribe(response => {
      if (response && response.body && response.body.datas) {
        this.messageOfTheDay = response.body.datas;
      }
    });
  }
  getPlatformMessages(): Observable<any> {
    return this.httpService.$post(ApiConst.getPlatformMessages, '');
  }

  clearPlatformMessages(context: string): Observable<any> {
    const dataToSend = {
      context: context
    };
    return this.updatePlatformMessage(ApiConst.clearPlatformMessages, dataToSend);
  }

  savePlatformMessages(frMsg: string, enMsg: string, context: string): Observable<any> {
    const dataToSend = {
      context: context,
      frMsg: frMsg,
      enMsg: enMsg
    };
    return this.updatePlatformMessage(ApiConst.savePlatformMessages, dataToSend);
  }

  private updatePlatformMessage(request: KindOfRequest, dataToSend: any): Observable<any> {
    return this.httpService.$post(request, dataToSend).pipe(map((response: any) => {
      if (response && response.body && response.body.datas) {
        this.messageOfTheDay = response.body.datas;
      } else if (response.body.bOK) {
        this.messageOfTheDay = {};
      }
      return response.body;
    }));
  }

  getUserMessageOfTheDay(): string {
    if (!this.messageOfTheDay) {
      return '';
    }
    const locale = this.storageService.getLangFromStorage();
    let mod = '';
    if (this.isLogged) {
      const cu = this.authService.getCurrentUser();
      if (this.messageOfTheDay[cu.idCustomer]) {
        if (locale === 'en') {
          mod = this.messageOfTheDay[cu.idCustomer].en;
        }
        if (!mod) {
          mod = this.messageOfTheDay[cu.idCustomer].fr;
        }
      } else if (this.messageOfTheDay.DEFAULT) {
        if (locale === 'en') {
          mod = this.messageOfTheDay.DEFAULT.en;
        }
        if (!mod) {
          mod = this.messageOfTheDay.DEFAULT.fr;
        }
      }
    } else {
      if (this.messageOfTheDay.DEFAULT) {
        if (locale === 'en') {
          mod = this.messageOfTheDay.DEFAULT.en;
        }
        if (!mod) {
          mod = this.messageOfTheDay.DEFAULT.fr;
        }
      }
    }
    return mod;
  }
}
